import { render } from "./Presenter.vue?vue&type=template&id=550ee222&scoped=true"
import script from "./Presenter.vue?vue&type=script&lang=js"
export * from "./Presenter.vue?vue&type=script&lang=js"

import "./Presenter.vue?vue&type=style&index=0&id=550ee222&scoped=true&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550ee222"]])

export default __exports__